import styled from 'styled-components';
import * as React from 'react';

interface IFramePageProps {
  children: React.ReactChild;
}

const IFramePage: React.FC<IFramePageProps> = ({ children }) => (
  <IFramePageContainer>
    <IFramePageContent>{children}</IFramePageContent>
  </IFramePageContainer>
);

const IFramePageContent = styled.div`
  padding: 30px;
`;

const IFramePageContainer = styled.div`
  height: auto;
  background-color: white;
`;

export { IFramePage };
